import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default class MultiCopyBlock {
    constructor() {
        if($('.js-multi-copy-block').length) {
            const $multiCopySlider = $('.js-multi-copy-block');

            $multiCopySlider.each(function() {
                const $slider = $(this)[0];

                const multiCopySlider = new Swiper($slider, {
                    autoHeight: true,
                    autoplay: {
                        delay: 15000
                    },
                    loop: true,
                    modules: [
                        Autoplay,
                        Pagination
                    ],
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 1
                });
            });
        };
    };
};
